import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        {/* Business details... */}
        <p>&copy; {currentYear} 맑은뷰연구소. All Rights Reserved.</p>
        <p>사업자등록번호: 727-74-00557 | 대표: 강준혁</p>
        {/* <p>주소: 경기도 오산시 내삼미로 40</p> */}
      </div>
    </footer>
  );
}

export default Footer;